import KeyValuePair from 'shared/models/key-value-pair';

export default interface ResidentSettingsFilterValue {
  filterValueType: FilterValueType;
  values: KeyValuePair[];
}

export enum FilterValueType {
  OrganisationUnit = 'OrganisationUnit',
  Scenario = 'Scenario',
  LinkedDevice = 'LinkedDevice',
  WanderingBoundary = 'WanderingBoundary',
  ScenariosMuted = 'ScenariosMuted',
}
